import { ProductPayment } from '../types/transactionTypes';

export function TransactionTrafficDetails({ paymentData }: { paymentData: ProductPayment }) {
    const utmSource = paymentData.pos_data.tags?.referrer || paymentData.pos_data?.tags?.utmSource || '-';
    const utmMedium = paymentData.pos_data.tags?.utmMedium || '-';
    const utmCampaign = paymentData.pos_data.tags?.utmCampaign || '-';

    return (
        <div className='flex w-full flex-col flex-wrap items-start gap-4 p-0 md:flex-row'>
            <div className='flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col'>
                <div className='text-gray text-sm font-semibold'>Source</div>
                <div className='ml-auto md:ml-0'>{utmSource}</div>
            </div>
            <div className='md:border-l-neutral-main flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                <div className='text-gray text-sm font-semibold'>Medium</div>
                <div className='ml-auto md:ml-0'>{utmMedium}</div>
            </div>
            <div className='md:border-l-neutral-main flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                <div className='text-gray text-sm font-semibold'>Campaign</div>
                <div className='ml-auto flex items-start md:ml-0'>
                    <div className="{ 'cursor-pointer': paymentData.page_id }">{utmCampaign}</div>
                </div>
            </div>
        </div>
    );
}
